import React, { Fragment } from 'react';
import styles from './FormInput.scss';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import DateTimePicker from '../../../common/components/DateTime/DateTimePicker';

class Input extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasBlurred: false,
            value: this.props.value,
        };

        this.onChange = this.onChange.bind(this);
        this.onChangeV4 = this.onChangeV4.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {

            this.setState({ value: this.props.value });
        }
        if (this.props.submitClicked) {
            this.isValid();
        }
    }

    onChange(e) {
        this.setState({ value: e.target.value });
        this.props.onChange(e);
    }

    onChangeV4(e) {
        this.setState({ value: e});
        this.props.onChange(e);
    }

    onBlur(e) {
        this.setState({ hasBlurred: true });
        this.props.onBlur(e);
    }

    isValid() {
        if (this.state.hasBlurred || this.props.submitClicked) {
            return this.props.isValid();
        } else {
            return true;
        }
    }

    getCharactersRemaining() {
        const value = this.state.value || '';
        return this.props.maxLength - value.length;
    }

    conditionallyRenderCharacterLimit() {
        return this.props.maxLength && (
            <span className={styles.textareaCharacterLimit}>{this.getCharactersRemaining()} characters remaining</span>
        );
    }

    render() {
        const {
            autoFocus,
            className,
            errorText,
            name,
            onClick,
            placeholder,
            required,
            title,
            type,
            disabled = false,
            max,
            min,
            withBackground = false,
            withBorder = false
        } = this.props;


        return (
            <div className={`${styles.parent, styles.inputContainer} ${!this.isValid() ? styles.input__invalid : ''} ${className}`} data-cy="FormInput">
                <div className={styles.header}>
                    <label htmlFor={title} className={[styles.title, withBorder && styles.titleGrey]} data-cy="FormInput-title">{title}</label>
                    {required ? <span className={styles.required}>Required</span> : null}
                </div>
                {type === 'textarea' && (
                    <Fragment>
                        <textarea
                            id={title}
                            className={classnames({
                                [styles.textarea]: true,
                                [styles.textareaWithBorder]: withBorder
                            })}
                            type={type}
                            name={name}
                            autoFocus={autoFocus}
                            onBlur={this.onBlur}
                            value={this.state.value ? this.state.value : ''}
                            placeholder={placeholder}
                            onChange={this.onChange}
                            required={required}
                            autoComplete={'off'}
                            rows={3}
                            maxLength={this.props.maxLength}
                            onKeyPress={(e) => e.key === 'Enter' && onClick && onClick()}
                            data-cy="FormInput-textarea"
                        />
                        {this.conditionallyRenderCharacterLimit()}
                    </Fragment>
                )}
                {type === 'dateV4' && (
                    <Fragment>
                        <div className={styles.inputWrapper}>
                            <DateTimePicker
                                id={title}
                                className={styles.DatePicker}
                                autoFocus={false}
                                time={false}
                                noTimezone={true}
                                value={this.state.value ? this.state.value : ''}
                                max={max}
                                min={min}
                                onChange={this.onChangeV4}
                                onKeyPress={(e) => e.key === 'Enter' && onClick && onClick()}
                                data-cy="FormInput-input-V4"
                            />
                        </div>
                    </Fragment>
                )}
                {type !== 'dateV4' && type !== 'textarea' && (
                    <Fragment>
                        <div className={styles.inputWrapper}>
                            <input
                                id={title}
                                className={classnames({
                                    [styles.inputWithTransparency]: !withBackground && !withBorder,
                                    [styles.inputWithBackground]: withBackground,
                                    [styles.inputWithWeightedFont]: className == 'weighted',
                                    [styles.inputWithBorder]: withBorder,
                                    [styles.removeInputBorder]: disabled,
                                })}
                                type={type}
                                name={name}
                                autoFocus={autoFocus}
                                disabled={disabled}
                                onBlur={this.onBlur}
                                value={this.state.value ? this.state.value : ''}
                                min={min}
                                placeholder={placeholder}
                                onChange={this.onChange}
                                required={required}
                                autoComplete={'off'}
                                onKeyPress={(e) => e.key === 'Enter' && onClick && onClick()}
                                maxLength={this.props.maxLength}
                                data-cy="FormInput-input"
                            />
                            {withBorder && (
                                <div className={styles.iconWrapper}>
                                    {type === 'date' && (
                                        <FontAwesomeIcon
                                            icon={faCalendarAlt}
                                            className={styles.icon}
                                        />
                                    )}
                                    {type === 'time' && (
                                        <FontAwesomeIcon
                                            icon={faClock}
                                            className={styles.icon}
                                        />
                                    )}
                                </div>
                            )}
                            {this.conditionallyRenderCharacterLimit()}
                        </div>
                    </Fragment>
                )}
                {!this.isValid() && <label className={styles.errorText}>{errorText}</label>}
            </div>
        );
    }
}

export default Input;
